import React, { useState, useEffect } from 'react';
import { Cookie, X } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'batiboys_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Hide automatically on public portal pages
    if (window.location.pathname.startsWith('/st/offer/') || window.location.pathname.startsWith('/st/demo') || window.location.pathname.startsWith('/client/demo') || window.location.pathname.startsWith('/client/reserves/')) return;
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: 'fixed',
        bottom: '16px',
        left: '16px',
        right: '16px',
        maxWidth: '720px',
        margin: '0 auto',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E2E6',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        zIndex: 9999,
        flexWrap: 'wrap',
      }}
    >
      <Cookie size={28} weight="fill" style={{ color: '#EF6C00', flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: '240px', fontSize: '0.88rem', color: '#2C2D33', lineHeight: 1.5 }}>
        Cette application utilise uniquement un <strong>stockage local technique</strong> necessaire a son fonctionnement (authentification, preferences). Aucun cookie publicitaire ou de suivi tiers n'est utilise.{' '}
        <Link to="/privacy" style={{ color: '#002FA7', fontWeight: '600' }}>En savoir plus</Link>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          className="btn btn-primary btn-sm"
          onClick={accept}
          data-testid="cookie-accept"
          style={{ whiteSpace: 'nowrap' }}
        >
          J'ai compris
        </button>
        <button
          onClick={accept}
          aria-label="Fermer"
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: '#5E5F66',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
